import { Component } from '@angular/core';

// Children of AppModule instead of AppMainModule
@Component({
    selector: 'my-page-layout-fullscreen',
    styles: [],
    template: require('./fullscreen.component.html')
})

export class PageLayoutFullscreenComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/page-layouts/fullscreen/fullscreen.component.ts